"use strict";

import cookie from "fg-cookie";
import Vue from "vue/dist/vue.common.js";
import VueRouter from "vue-router";
import VueResource from "vue-resource";
import EventBus from './event-bus';
// Vuex
import store from "../vuex/store";
// Components
import Modal from "../components/modal";
import JoinSquad from "../components/join-squad";
import SquadForm from "../components/squad-form";
import SquadMap from "../components/squad-map";
import SquadListing from "../components/squad-listing";

Vue.use(VueResource);
Vue.use(VueRouter);

const cookieID = "kCp8WQTiVSOLE9nVipPnfuKVxxccra";
let userGeolocation;

// Router config
export const router = new VueRouter({
  mode: "history",
  base: window.location.pathname,
  routes: [
    // Rerdirect all default requests to the map
    // {
    //   path: "/",
    //   redirect: {
    //     name: "map"
    //   }
    // },
    {
      name: "map",
      path: "/",
      component: SquadMap,
      props: route => ({
        query: route.query.q,
        geoLocation:  (!!route.query.g ? JSON.parse(route.query.g) : null)
      })
    },
    {
      name: "listing",
      path: "?squad_view=listing",
      component: SquadListing,
      props: route => ({
        query: route.query.q,
        geoLocation: (!!route.query.g ? JSON.parse(route.query.g) : null)
      })
    }
  ]
});

let Squads = Vue.extend({
  store,
  router,

  data() {
    return {
      bounds: [[-180, 20], [-30, 72]],
      query:"",
      mapApiUrl:"",
      listingApiUrl:"",
    };
  },

  components: {
    Modal,
    JoinSquad,
    SquadForm,
    SquadMap,
    SquadListing
  },

  computed: {
    joining() {
      return this.$store.state.squadSearch.joining;
    },
    joinSquadTitle() {
      return 'Join ' + this.$store.state.squadSearch.squad.name;
    }
  },

  beforeMount() {
    // Fetch the API urls supplied by the BE
    this.mapApiUrl = this.$el.getAttribute('map-api-url');
    this.listingApiUrl = this.$el.getAttribute('listing-api-url');
  },

  mounted() {
    if (typeof this.$route.query.q !== 'undefined') {
      this.query = this.$route.query.q
    } else if (typeof this.$route.query.g !== 'undefined') {
      this.geoLocation = JSON.parse(this.$route.query.g);
    }

    EventBus.$on('closeModal', () => {
      this.$store.commit('squadSearch/setJoining', false);
      this.$store.commit('squadSearch/setJoined', false);
    });
  },

  methods: {
    setQuery() {
      this.$router.push({ query: { q: this.query } });
    },

    /**
     * Aquire users geolocation
     * checks if it's already stored in a cookie, otherwise requestes
     * updated coordinates
     */
    geoLocateUser() {
      // Clear current query value
      this.$router.push({ query: {}});
      this.query = "";
      const geoCookie = cookie(cookieID);
      // Check if the users current Geo Location was already stored.
      if (geoCookie) {
        userGeolocation = JSON.parse(geoCookie);
        this.$router.push({ query: { g: JSON.stringify(userGeolocation) } })
      } else {
        navigator.geolocation.getCurrentPosition(position => {
          var pos = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          };
          userGeolocation = JSON.stringify(pos);
          cookie(cookieID, userGeolocation, 1/72);
          this.$router.push({ query: { g: JSON.stringify(userGeolocation) } })

        }, (err)=> {
          alert('Sorry, we were unable to detect your current location. Try search with a location keyword or mailing zipcode.')
        });
      }
    }
  }
});

export default Squads;



// WEBPACK FOOTER //
// ./app/javascript/vue/instances/squads.js